export class Tenant{
    tenant: string | undefined;
}